import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f73744bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-accordion" }
const _hoisted_2 = {
  key: 0,
  class: "accordion-content"
}

import { computed, ref } from 'vue';
  
  import { themingCssClass } from "../../mixins/theming-mixin";
  import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-accordion',
  props: {...recProps()},
  setup(__props) {

  

  const expanded = ref<boolean>(false);
  const expandIconClass = computed(()=> expanded.value ? "fi-expand_less" : "fi-expand_more");
  const expandedClass = computed(()=> expanded.value ? "expanded" : "retrieved");

  const toggle = () => { expanded.value = !expanded.value }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["accordion-top", expandedClass.value]),
      onClick: toggle
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["accordion-title", [_unref(themingCssClass)('normal')]])
      }, _toDisplayString(_ctx.description.accordion_title), 3),
      _createElementVNode("div", {
        class: _normalizeClass(["accordion-chevron", [_unref(themingCssClass)('normal')]])
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["frontend-icon", expandIconClass.value])
        }, null, 2)
      ], 2)
    ], 2),
    (
        expanded.value &&
        _ctx.description &&
        _ctx.description.content &&
        _ctx.description.content.component
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.description.content.component), {
            description: _ctx.description.content,
            onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('submit')))
          }, null, 40, ["description"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})